import Swiper from "swiper";
import "swiper/css/swiper.css";

function tombstonesCarousel(tombstoneEl) {
  // If called without an element, exit.
  if (!tombstoneEl) return;

  let slider = tombstoneEl.querySelectorAll('.tombstones-slider');
  let prevBtn = tombstoneEl.querySelector('.swiper-button-prev-ext');
  let nextBtn = tombstoneEl.querySelector('.swiper-button-next-ext');

  let sliderOptions = {
    loopAdditionalSlides: 1,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 4,
    breakpoints: {
      480: {
        slidesPerView: 2
      },
      620: {
        slidesPerView: 3
      },
      960: {
        slidesPerView: 4
      }
    },
    init: false
  };

  let swiperInstance = new Swiper(slider, sliderOptions);

  const panelCount = slider[0].querySelectorAll(".swiper-slide").length;
  
  // If we have less slides than can be shown on the screen
  // at a time, just hide the arrows
  if ( !shouldSliderInitiate( panelCount ) ) {
    prevBtn.style.display = 'none';
    nextBtn.style.display = 'none';
  }

  // Init slider after determining if arrows should show,
  // otherwise the options are reset to what's set in sliderOptions.
  swiperInstance.init();
  
  // If we hide the arrows, we disable scrolling.
  if ( !shouldSliderInitiate( panelCount ) ) swiperInstance.allowTouchMove = false;
  
  // Attach click event to buttons if it exists
  if (prevBtn) {
    prevBtn.onclick = function(e) {
      e.preventDefault();
      swiperInstance.slidePrev();
    };
  }
  if (nextBtn) {
    nextBtn.onclick = function(e) {
      e.preventDefault();
      swiperInstance.slideNext();
    };
  }
  
}

function shouldSliderInitiate(panelCount) {
  let breakpoints = [0, 480, 620, 960, 9999];
  let slidesPerView = [1, 2, 3, 4];

  let shouldInit = false;

  for (let breakpoint in breakpoints) {
    // Is this screen width in a breakpoint area?
    if (
      window.innerWidth > breakpoints[breakpoint] && 
      window.innerWidth < breakpoints[Number(breakpoint) + 1]
    ) {
      // If so, are there enough panels to initialize the
      // slider, or not?
      if (panelCount > slidesPerView[breakpoint]) {
        shouldInit = true;
      }
    }
  }

  return shouldInit;
}


export default tombstonesCarousel;
